import { createNameContext } from '@showroomjs/ui';
import * as React from 'react';
const CodeVariablesContext = createNameContext('CodeVariablesContext', {});
export const CodeVariablesContextProvider = CodeVariablesContext.Provider;
export const useCodeVariables = () => React.useContext(CodeVariablesContext);
//# sourceMappingURL=code-variables-context.js.map